<template>
  <header class="bg-white dark:bg-gray-950 shadow flex items-center h-12 px-3 justify-between border-b border-gray-100 dark:border-gray-800">
    <div class="flex items-center min-w-0 gap-3">
      <button @click="$emit('toggleSidebar')" class="md:hidden">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"/>
        </svg>
      </button>
      <span v-if="breadcrumb" class="text-sm font-semibold truncate dark:text-white">{{ breadcrumb }}</span>
      <span v-if="negocioActual" class="flex items-center gap-1.5 px-2 py-0.5 rounded bg-blue-100 dark:bg-blue-900 text-blue-700 dark:text-blue-200 font-medium text-xs shadow-sm">
        <svg class="w-3.5 h-3.5 text-blue-500 dark:text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 7V6a1 1 0 011-1h16a1 1 0 011 1v1M4 7l1.447 9.632A2 2 0 007.43 18h9.14a2 2 0 001.983-1.368L20 7M4 7h16M9 21h6" />
        </svg>
        <span class="hidden sm:inline">Negocio:</span>
        <span class="font-semibold">{{ negocioActual }}</span>
      </span>
    </div>
    <div class="flex items-center gap-2 relative">
      <!-- Dark mode toggle -->
      <button @click="toggleDark" class="p-1.5 rounded hover:bg-gray-100 dark:hover:bg-gray-800">
        <svg v-if="!isDark" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 3v1m0 16v1m8.66-13.66l-.71.71M4.05 19.07l-.71.71M21 12h-1M4 12H3m16.66 6.66l-.71-.71M4.05 4.93l-.71-.71M16 12a4 4 0 11-8 0 4 4 0 018 0z"/>
        </svg>
        <svg v-else class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 12.79A9 9 0 1111.21 3a7 7 0 109.79 9.79z"/>
        </svg>
      </button>
      <!-- Notifications -->
      <div class="relative">
        <button @click="toggleNotifications" class="p-1.5 rounded hover:bg-gray-100 dark:hover:bg-gray-800 relative">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"/>
          </svg>
          <span class="absolute top-0.5 right-0.5 w-1.5 h-1.5 bg-red-500 rounded-full"></span>
        </button>
        <div v-if="showNotifications" class="absolute right-0 mt-2 w-80 bg-white dark:bg-gray-800 rounded-xl shadow-lg z-50">
          <div class="p-4 border-b font-semibold flex justify-between items-center dark:border-gray-700 dark:text-white">
            Notifications
            <span class="bg-violet-100 text-violet-700 text-xs px-2 py-1 rounded">2 New</span>
          </div>
          <ul>
            <li v-for="n in notifications" :key="n.id" class="flex items-start gap-3 px-4 py-3 border-b last:border-b-0 hover:bg-gray-50 dark:hover:bg-gray-700 dark:border-gray-700">
              <img :src="n.avatar" class="w-10 h-10 rounded-full" v-if="n.avatar" />
              <div v-else class="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center text-gray-500 font-bold">{{ n.initials }}</div>
              <div class="flex-1">
                <div class="font-semibold dark:text-white">{{ n.title }}</div>
                <div class="text-xs text-gray-500 dark:text-gray-300">{{ n.message }}</div>
                <div class="text-xs text-gray-400 mt-1">{{ n.time }}</div>
              </div>
              <span v-if="n.unread" class="w-2 h-2 bg-violet-500 rounded-full mt-2"></span>
            </li>
          </ul>
          <div class="p-3">
            <button class="w-full bg-violet-500 text-white py-2 rounded-lg font-semibold">View All Notifications</button>
          </div>
        </div>
      </div>
      <!-- Profile -->
      <div class="relative">
        <button ref="avatarBtnRef" @click="toggleProfileMenu" class="focus:outline-none">
          <img src="https://randomuser.me/api/portraits/men/5.jpg" class="w-7 h-7 rounded-full border-2 border-white shadow" />
          <span class="absolute bottom-0 right-0 w-2 h-2 bg-green-400 border border-white rounded-full"></span>
        </button>
        <div
          v-if="showProfileMenu"
          ref="profileMenuRef"
          class="absolute right-0 mt-2 w-64 bg-white dark:bg-gray-800 rounded-xl shadow-lg z-50"
        >
          <div class="flex items-center gap-3 p-4 border-b dark:border-gray-700">
            <img src="https://randomuser.me/api/portraits/men/5.jpg" class="w-12 h-12 rounded-full border-2 border-violet-400" />
            <div>
              <div class="font-bold dark:text-white">{{ nombreUsuario }}</div>
              <div class="text-xs text-gray-500">{{ rolUsuario }}</div>
            </div>
          </div>
          <!-- <ul class="py-2">
            <li><router-link to="/profile" class="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white"><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5.121 17.804A13.937 13.937 0 0112 15c2.5 0 4.847.655 6.879 1.804M15 11a3 3 0 11-6 0 3 3 0 016 0z"/></svg> Profile</router-link></li>
            <li><router-link to="/settings" class="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white"><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3"/></svg> Settings</router-link></li>
            <li class="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-6a2 2 0 012-2h2a2 2 0 012 2v6m-6 0h6"/></svg>
              Billing Plan <span class="ml-auto bg-red-500 text-white text-xs px-2 py-0.5 rounded">4</span>
            </li>
            <li><router-link to="/pricing" class="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white"><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 1.343-3 3s1.343 3 3 3 3-1.343 3-3-1.343-3-3-3z"/></svg> Pricing</router-link></li>
            <li><router-link to="/faq" class="flex items-center gap-2 px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white"><svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 14h.01M16 10h.01M21 12c0 4.418-4.03 8-9 8s-9-3.582-9-8 4.03-8 9-8 9 3.582 9 8z"/></svg> FAQ</router-link></li>
          </ul> -->
          <div class="p-4">
            <button @click="logout" class="w-full bg-red-500 text-white py-2 rounded-lg font-semibold flex items-center justify-center gap-2">
              Logout
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7"/></svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script setup>
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useUserStore } from '@/stores/user';

const isDark = ref(false);
const showNotifications = ref(false);
const showProfileMenu = ref(false);
const router = useRouter();
const route = useRoute();
const userStore = useUserStore();

const profileMenuRef = ref(null);
const avatarBtnRef = ref(null);

// Breadcrumb dinámico solo con el nombre de la página actual
const breadcrumb = computed(() => {
  // Puedes personalizar aquí para mostrar nada en ciertas rutas
  const map = {
    '/dashboard': 'Dashboard',
    '/analytics': 'Analíticas',
    '/products': 'Lista de Productos',
    '/profile': 'Perfil de Usuario',
  };
  return map[route.path] || '';
});

const rolUsuario = computed(() => userStore.usuario.rol);
const nombreUsuario = computed(() => userStore.usuario.nombre );
const negocioActual = computed(() => userStore.negocioSeleccionado?.nombre || null);

function toggleDark() {
  isDark.value = !isDark.value;
  document.documentElement.classList.toggle('dark', isDark.value);
  localStorage.setItem('theme', isDark.value ? 'dark' : 'light');
}

onMounted(() => {
  // Leer preferencia de dark mode
  const theme = localStorage.getItem('theme');
  if (theme === 'dark') {
    isDark.value = true;
    document.documentElement.classList.add('dark');
  } else {
    isDark.value = false;
    document.documentElement.classList.remove('dark');
  }
});

function toggleNotifications() {
  showNotifications.value = !showNotifications.value;
  showProfileMenu.value = false;
}
function toggleProfileMenu() {
  showProfileMenu.value = !showProfileMenu.value;
  showNotifications.value = false;
}
function logout() {
  localStorage.removeItem('token');
  userStore.logout();
  router.push('/login');
}

function handleClickOutside(event) {
  if (
    showProfileMenu.value &&
    profileMenuRef.value &&
    !profileMenuRef.value.contains(event.target) &&
    avatarBtnRef.value &&
    !avatarBtnRef.value.contains(event.target)
  ) {
    showProfileMenu.value = false;
  }
}

watch(showProfileMenu, (open) => {
  if (open) {
    document.addEventListener('mousedown', handleClickOutside);
  } else {
    document.removeEventListener('mousedown', handleClickOutside);
  }
});

onBeforeUnmount(() => {
  document.removeEventListener('mousedown', handleClickOutside);
});

const notifications = [
  { id: 1, avatar: 'https://randomuser.me/api/portraits/women/44.jpg', title: 'Congratulation Flora! 🎉', message: 'Won the monthly best seller badge', time: 'Today', unread: true },
  { id: 2, initials: 'TH', title: 'New user registered.', message: '', time: '5 hours ago', unread: true },
  { id: 3, avatar: 'https://randomuser.me/api/portraits/men/32.jpg', title: 'New message received 👋🏻', message: 'You have 10 unread messages', time: '11 Aug', unread: false },
  { id: 4, avatar: '', title: 'PayPal', message: 'Received Payment', time: '25 May', unread: false },
];
</script> 